import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UploadPdfBillComponent } from './upload-pdf-bill.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { AddBillDirectiveModule } from '../directives/add-bill-directive.module';
// import { PhotoBillPreviewModule } from './photo-bill-preview/photo-bill-preview.module';

@NgModule({
  declarations: [UploadPdfBillComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    // PhotoBillPreviewModule,
    // AddBillDirectiveModule
  ],
  entryComponents: [UploadPdfBillComponent],
  exports: [UploadPdfBillComponent]
})
export class UploadPdfBillComponentModule { }
